// Root Reducer

import { combineReducers } from "redux";
import authUserReducer from "./authUser";
import distributerReducer from "./DistributerReducer";

export let rootReducer = combineReducers({
    authUser: authUserReducer,
    distributer: distributerReducer,
});

export default rootReducer;
